import { randomIntegerBetween } from 'lib/maths/mathUtils'

export function mockLuxLoyaltyProgramConfigResponse() {
  return {
    status: 200,
    result: {
      config: {
        programName: 'luxloyalty',
        currencyName: 'points',
        statusCreditsName: 'status credits',
        tierLabel: 'traveller status',
        tiers: {
          gold: {
            tierName: 'gold',
            welcomePoints: 2000,
          },
          silver: {
            tierName: 'silver',
            welcomePoints: 1000,
          },
          platinum: {
            tierName: 'platinum',
            welcomePoints: 3000,
          },
        },
      },
    },
  }
}

/**
 *
 * @TODO replace when svc is ready
 */
export function mockPointsAndCreditsEarned() {
  const statusCreditsEarned = randomIntegerBetween(100, 500)

  return {
    orderPointsEarned: statusCreditsEarned * 10,
    statusCreditsEarned,
  }
}
